import { useMutation } from '@apollo/client/react';
import { useAtom } from 'jotai';
import { useResetAtom } from 'jotai/utils';
import { useCallback } from 'react';

import { GenerateDeliveryCsvDocument } from '~/graphql/generated/graphql';
import { b2CloudDownloadModalState } from '~/state/reception/atoms';

export const useGenerateCsv = () => {
  const [{ appointmentIds }, setModalState] = useAtom(b2CloudDownloadModalState);
  const resetModalState = useResetAtom(b2CloudDownloadModalState);

  const [generateCsv] = useMutation(GenerateDeliveryCsvDocument);

  const setError = useCallback(
    (message: string | null) => {
      setModalState((_state) => ({ ..._state, error: message }));
    },
    [setModalState],
  );
  const generate = useCallback(
    async (willFinished: boolean) => {
      if (appointmentIds.length === 0) {
        setError('ダウンロードする患者を選択してください');
        return;
      } else {
        setError(null);
      }

      try {
        setModalState((_state) => ({ ..._state, disabled: true }));

        const result = await generateCsv({
          variables: {
            input: {
              appointmentIds,
              willFinished,
            },
          },
        });
        const url = result.data?.generateDeliveryCsv?.blob?.url;
        if (!url) {
          setError('エラーが発生しました。再度実行してください');
          return;
        }

        const link = document.createElement('a');
        link.href = url;
        link.click();

        resetModalState();
      } catch (_error) {
        setError(_error?.message || 'エラーが発生しました');
      } finally {
        setModalState((_state) => ({ ..._state, disabled: false }));
      }
    },
    [appointmentIds, generateCsv, setError, setModalState, resetModalState],
  );

  return generate;
};
